module.exports = __webpack_public_path__ + "static/ZopSmartWhitePaper-b3254bc9c6cc080d06d93cb03071c900.pdf";